import axios from "axios"

// Get customer attributes
async function getCustomerAttributesApi(uuid: string, clientUuid: string) {
    return axios({
        method: 'GET',
        url: `/api/v1/workspaces/${uuid}/clients/${clientUuid}/attributes`
    });
}

// Post customer attribute
async function postCustomerAttributeApi(uuid: string, clientUuid: string, data: { attributeId: any; content: any }) {
    return axios({
        method: 'POST',
        url: `/api/v1/workspaces/${uuid}/clients/${clientUuid}/attributes`,
        data: data
    });
}

// Delete customer attribute
async function deleteCustomerAttributeApi(uuid: string, clientUuid: string,attributeUuid: string) {
    return axios({
        method: 'DELETE',
        url: `/api/v1/workspaces/${uuid}/clients/${clientUuid}/attributes/${attributeUuid}`,
    });
}

async function patchCustomerAttributeApi(uuid: string, clientUuid: string, clientAttributeUuid:string, attributeContent: string) {
    return axios({
        method: 'PATCH',
        url: `api/v1/workspaces/${uuid}/clients/${clientUuid}/attributes/${clientAttributeUuid}`,
        data:{
            content: attributeContent
        }
    });
}

export {
    deleteCustomerAttributeApi,
    patchCustomerAttributeApi,
    getCustomerAttributesApi,
    postCustomerAttributeApi
}